import { Cookies } from 'react-cookie';
import { toastError, toastSuccess } from '../utils/toastMessage';
import * as actionTypes from '../constants/constants';
import API from '../utils/API';

const cookies = new Cookies();

export const LoginSuccess = (username, password) => {
  return {
    type: actionTypes.LOGIN_SUCCESS,
    username: username,
    password: password,
  };
};

export const logout = () => {
  cookies.remove('user');
  return {
    type: actionTypes.LOGOUT,
    username: '',
    password: '',
  };
};

export const Login = (username, password) => {
  return (dispatch) => {
    API.get('/users', {
      auth: {
        username: username,
        password: password,
      },
    })
      .then(() => {
        toastSuccess('Авторизация прошла успешно!', 'Успех');

        cookies.set('user', { username, password });
        dispatch(LoginSuccess(cookies.get('user').username, cookies.get('user').password));
      })
      .catch(() => {
        toastError('Логин или пароль неверны.', 'Ошибка авторизации');
      });
  };
};



// WEBPACK FOOTER //
// ./src/actions/login.js